// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "-" + {"672":"b0d403a3f597e720051f","849":"a5da3da02c840520c593"}[chunkId] + ".chunk.js";
};